var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgProtectionShield = function SvgProtectionShield(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M20 12c0 2.127-1.5 6.75-7.5 9-6-2.25-7.375-6.625-7.5-9V5.939L12.5 3 20 5.939z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 0.8,
    d: "M12.5 8.25a1.13 1.13 0 0 1 1.125 1.125V10.5h-2.25V9.375A1.13 1.13 0 0 1 12.5 8.25m1.875 2.25V9.375A1.88 1.88 0 0 0 12.5 7.5a1.88 1.88 0 0 0-1.875 1.875V10.5h-.375a.75.75 0 0 0-.75.75v3c0 .414.336.75.75.75h4.5a.75.75 0 0 0 .75-.75v-3a.75.75 0 0 0-.75-.75zm-4.125.75h4.5v3h-4.5z"
  })));
};
export default SvgProtectionShield;